/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useCallback } from 'react'
import {
  deleteInvoiceTemplateById,
  downloadInvoiceTemplateById,
  fetchInvoiceTemplateById,
  uploadInvoiceTemplate
} from '../../lib/rest/invoiceTemplateAPIClient'
import FileTemplateManager, { FileTemplateManagerProps } from '../FileTemplateManager'
import { useQuery } from '@tanstack/react-query'

export type InvoiceTemplateFileFieldProps =
  Omit<FileTemplateManagerProps, 'onChange' | 'onDelete' | 'onDownload' | 'onUpload'>
  & {
  item: {
    title: string,
    description: string,
    type: string,
  }
}

function InvoiceTemplateField (props: InvoiceTemplateFileFieldProps) {
  const { item, ...others } = props
  const filename = `${item.type}.docx`

  const handleDelete = useCallback(() => deleteInvoiceTemplateById(filename), [filename])
  const handleDownload = useCallback(() => downloadInvoiceTemplateById(filename), [filename])
  const handleUpload = useCallback((file: File) => uploadInvoiceTemplate(filename, file), [filename])

  const fileQuery = useQuery({
    enabled: true,
    queryKey: ['invoiceTemplate', filename],
    queryFn: () => fetchInvoiceTemplateById(filename)
  })

  return (
    <FileTemplateManager
      description={item.description}
      label={item.title}
      loading={fileQuery.isLoading}
      onChange={() => fileQuery.refetch()}
      onDelete={handleDelete}
      onDownload={handleDownload}
      onUpload={handleUpload}
      value={fileQuery.data ? filename : null}
      lastModified={fileQuery.data?.LastModified}
      contentLength={fileQuery.data?.ContentLength}
      {...others}
    />
  )
}

export default InvoiceTemplateField
